'use client';

import { getChainSlug } from '@revoke.cash/core/chains';
import ChainSelectHref from 'components/common/select/ChainSelectHref';
import { useCallback } from 'react';

interface Props {
  chainId: number;
}

// This is a wrapper around ChainSelectHref because we cannot pass the getUrl function as a prop from a server component
const AddNetworkChainSelect = ({ chainId }: Props) => {
  const getUrl = useCallback((chainId: number) => `/learn/wallets/add-network/${getChainSlug(chainId)}`, []);
  return <ChainSelectHref instanceId="add-network-chain-select" selected={chainId} getUrl={getUrl} showNames />;
};

export default AddNetworkChainSelect;
